/*
 * @Author: luxiangying3
 * @Date: 2020-10-15
 * @Description: 存放根actions
 */

import * as Types from './mutationsType'

export default {
    [Types.APPID] ({ commit }, payload) {
        commit(Types.APPID, payload)
    },
    [Types.IS_ADMIN] ({ commit }, payload) {
        commit(Types.IS_ADMIN, payload)
    },
    [Types.ROUTE_NAME] ({ commit }, payload) {
        commit(Types.ROUTE_NAME, payload)
    },
    [Types.APP_HANDLE_FLAG] ({ commit }, payload) {
        commit(Types.APP_HANDLE_FLAG, payload)
    }
}